<script setup>
import { useForm } from '@/composables/form/form';

const emit = defineEmits(['submit:error', 'submit:success', 'update:submitting']);

const props = defineProps({
    fill: {
        type: Object,
    },
    submitUsing: {
        type: Function,
        required: false,
    },
    url: {
        type: String,
        required: false,
    },
    method: {
        type: String,
        required: false,
        default: 'post',
    },
    transformRequestUsing: {
        type: [Function, Array],
        required: false,
    },
    headers: {
        type: Object,
        required: false,
    },
    params: {
        type: Object,
        required: false,
    },
    draftItemType: {
        type: String,
        required: false,
    },
    draftItemId: {
        type: [String, Number],
        required: false,
    },
    disabled: {
        type: Boolean,
        required: false,
        default: false,
    },
    debug: {
        type: [Boolean, String],
        required: false,
        default: false,
    },
    markAsRequired: {
        type: Boolean,
        default: false,
    },
    clearAfterSubmit: {
        type: Boolean,
        default: false,
    }
});

const form = useForm({ props, emit });

defineExpose({
    form
});
</script>

<template>
    <form class="w-full" @submit.prevent="form.submit()" :action="url" :method="method" :disabled="disabled">
        <pre v-if="debug === 'verbose' && form.inDebugMode()">
            {{ form.getState() }}
        </pre>
        <slot :form="form"></slot>
    </form>
</template>
